import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trouble-tickets--batch-edit-modal"
export default class extends Controller {
  static targets = ["resolutionText"]
  static values = { closedStateId: Number }
  
  connect() {
    this.form = this.element.querySelector('form')

    this.categoriesAddSelect = this.form.querySelector('#category_ids_to_add');
    this.categoriesRemoveSelect = this.form.querySelector('#category_ids_to_remove');
    
    $(this.categoriesAddSelect).select2({
      width: '100%',
      placeholder: 'Select categories to add to selected problem reports',
      dropdownParent: $('#batchEdit'),
      allowClear: true
    })

    $(this.categoriesRemoveSelect).select2({
      width: '100%',
      placeholder: 'Select categories to remove from selected problem reports',
      dropdownParent: $('#batchEdit'),
      allowClear: true
    })
  }

  disconnect() {
    if (this.categoriesAddSelect) {
      $(this.categoriesAddSelect).select2('destroy');
    }
    if (this.categoriesRemoveSelect) {
      $(this.categoriesRemoveSelect).select2('destroy');
    }
  }

  handleStateChange(event) {
    const selectedValue = event.target.value ? parseInt(event.target.value) : null
    this.resolutionTextTarget.required = selectedValue === this.closedStateIdValue;
  }
}
